/**
 * Mirrors config/enums.php `user_roles`, which is the source of truth for the
 * values. The labels live here because they are presentation, not part of the
 * API contract.
 *
 * EnumFilter treats a column's options as an allow list: a role missing from
 * here can never show up in a filtered result, so anything added to
 * config/enums.php must be added here too.
 */
const objects = {
    super_admin: { value: 'super_admin', label: 'Super Admin' },
    admin: { value: 'admin', label: 'Admin' },
    field_user: { value: 'field_user', label: 'Field User' },
    mission_control_user: { value: 'mission_control_user', label: 'Mission Control User' },
    support_admin: { value: 'support_admin', label: 'Support Admin' },
    developer: { value: 'developer', label: 'Developer' },
    app_repository_user: { value: 'app_repository_user', label: 'App Repository User' },
    logistics_manager: { value: 'logistics_manager', label: 'Logistics Manager' },
    premium_firmware_installer: { value: 'premium_firmware_installer', label: 'Premium Firmware Installer' },
    relay_manager_user: { value: 'relay_manager_user', label: 'Relay Manager User' },
}

export default Object.freeze(objects)

export const byValue = (value) => objects[value]

export const userRoleOptions = Object.freeze(Object.values(objects))

/**
 * The roles a privileged user may be given. Privileged users are staff rather
 * than customers, so they are limited to the roles that make sense for someone
 * belonging to no organization. Mirrors config/enums.php
 * `privileged_user_roles`, which is what the API validates against.
 */
export const privilegedUserRoleOptions = Object.freeze([objects.super_admin, objects.developer, objects.support_admin])
